module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"chooseItem":"Wähle diesen Artikel","chooseItems":"Wähle einen dieser Artikel"},"en":{"chooseItem":"Select this item","chooseItems":"Choose one from these items"}}')
  delete Component.options._Ctor
}
